import { isPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

export const isPreApprovalFailedOffer = (offer: TOffer) =>
  isPreApprovalOffer(offer) && offer.preApprovalStatus === 'FAILED';
